import type { CluePayload } from '@guess/engine';
import type { ClueProps } from './ClueRenderer';
import s from './clue.module.scss';

type ListPayload = Extract<CluePayload, { kind: 'list' }>;

/**
 * La liste melangee, telle que le serveur l'a tiree.
 *
 * Attention : cette liste est l'INDICE, pas l'entree. Pour le mini-jeu
 * `order`, le joueur manipule la liste de `InputSpec` — c'est
 * `OrderInput` qui s'en charge. Les deux se ressemblent a l'ecran mais ne
 * jouent pas le meme role, et les confondre ferait d'un indice une reponse.
 *
 * Elle reste donc en lecture seule, et se contente de numeroter.
 */
export function ListClue({ payload }: ClueProps<ListPayload>) {
  return (
    <ol className={s.list}>
      {payload.items.map((item, index) => (
        <li key={item.id} className={s.listItem} style={{ animationDelay: `calc(var(--dur-fast) * ${index})` }}>
          {item.imageUrl ? <img className={s.listThumb} src={item.imageUrl} alt="" /> : null}
          <span className={s.listLabel}>{item.label}</span>
        </li>
      ))}
    </ol>
  );
}
